export const ASAP = 1;
export const Scheduled = 2;
export const No_Inventory = 0;
